import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('trash.certificates'),
      path: 'trash/certificates',
      use_parent_params: true,
      params_required: ['idEmpresa', 'serial', 'tipo'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'trash/certificates/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'trash/certificates/historical',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
